import { render, staticRenderFns } from "./huanBi.vue?vue&type=template&id=1a684218&scoped=true&"
import script from "./huanBi.vue?vue&type=script&lang=js&"
export * from "./huanBi.vue?vue&type=script&lang=js&"
import style0 from "./huanBi.vue?vue&type=style&index=0&id=1a684218&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a684218",
  null
  
)

export default component.exports